import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import qs from 'query-string';

import getEnvConfig from 'utils/config/env';

import { PaginatedResponse } from '../../../../communities/interfaces/PaginatedResponse';
import { ShopDetailsProps, ShopDetailsRequest } from './shop-details.interface';
import { authHeader } from '../../../../../utils/common/authHeader';

export const adminShopDetailsApi = createApi({
    reducerPath: 'adminShopDetailsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: getEnvConfig().env.API_URL + '/manager',
        prepareHeaders: (headers: Headers) => authHeader(headers),
    }),
    tagTypes: ['shopDetails'],

    endpoints: build => ({
        readShopsAdmin: build.query<
            PaginatedResponse<ShopDetailsProps>,
            ShopDetailsRequest
        >({
            query: payload => {
                const queryArgs = qs.stringify(payload.filters, {
                    arrayFormat: 'bracket-separator',
                    skipNull: true,
                });
                return {
                    url: `shop-details?${queryArgs}`,
                };
            },
            transformResponse: (res: { data: ShopDetailsProps[] }, meta) => {
                return {
                    items: res.data || [],
                    total:
                        Number(meta.response.headers.get('Items-count')) || 0,
                };
            },
            providesTags: ['shopDetails'],
        }),

        readShopDetail: build.query<
            PaginatedResponse<ShopDetailsProps>,
            ShopDetailsRequest
        >({
            query: payload => {
                const queryArgs = qs.stringify(payload.filters, {
                    arrayFormat: 'bracket-separator',
                    skipNull: true,
                });
                return {
                    url: `shop-details?${queryArgs}`,
                };
            },
            transformResponse: (res: { data: ShopDetailsProps[] }, meta) => {
                return {
                    items: res.data || [],
                    total:
                        Number(meta.response.headers.get('Items-count')) || 0,
                };
            },
            providesTags: ['shopDetails'],
        }),
    }),
});

export const { useLazyReadShopsAdminQuery } = adminShopDetailsApi;
